// Copyright (c) 2018 Deere & Company

import OktaAuth from '@okta/okta-auth-js';
import {getStore} from '../../store-factory';
import {oktaLoginRequired} from './okta-login-required';
import {when} from './when';

let authClient,
    oktaConfig;

const OktaTokenConfig = {
    responseType: [
        'token',
        'id_token'
    ],
    scopes: [
        'openid',
        'profile',
        'warrantyApiAdgroups'
    ]
};

export function authError(error) {

    document.location.href = `AUTH_ERROR.html?errorType=${error.name}&errorCode=${error.errorCode}&message=${error.message}`;

}

export async function setTokens(tokens) {

    try {

        await authClient.tokenManager.add('accessToken', tokens[0]);
        await authClient.tokenManager.add('idToken', tokens[1]);

    } catch (e) {

        authError(e);

    }

}

export async function getOktaTokens(initial = false) {

    window.tokenRequestInFlight = true;

    await authClient.token.parseFromUrl()
        .then(async tokens => {

            await setTokens(tokens);

        },
        async () => {

            await authClient.token.getWithoutPrompt(OktaTokenConfig)
                .then(async tokens => {

                    await setTokens(tokens);

                }, async e => {

                    if (e.errorCode === 'login_required') {

                        if (initial === false) {

                            oktaLoginRequired();

                        } else {

                            await new Promise(resolve => {

                                /* eslint-disable consistent-return */

                                const beforeRedirectHost = location.host;

                                authClient.token.getWithRedirect(OktaTokenConfig);

                                const waitForRedirect = () => {

                                    if (location.host !== beforeRedirectHost) {

                                        return resolve();

                                    }
                                    setTimeout(waitForRedirect, 1000);

                                };

                                /* eslint-enable consistent-return */

                            });

                        }

                    } else {

                        // real OAuthError

                        authError(e);

                    }

                });

        });

    window.tokenRequestInFlight = false;

}

export async function oktaToken(tokenName, forceInitial = false) {

    let token;

    token = await authClient.tokenManager.get(tokenName);

    if (typeof token === 'undefined') {

        // if a request for a new token is already in flight, do not send additional requests

        if (window.tokenRequestInFlight) {

            token = await when(() => !window.tokenRequestInFlight, 1000, 20).then(async () => await authClient.tokenManager.get(tokenName)).catch(err => err);

        } else {

            await getOktaTokens(forceInitial);
            token = await authClient.tokenManager.get(tokenName);

        }

    }

    return token;

}

export async function logout() {

    const idToken = await oktaToken('idToken');

    await authClient.tokenManager.clear();
    document.location.href = `${oktaConfig.issuer}/v1/logout?id_token_hint=${idToken.idToken}&post_logout_redirect_uri=${oktaConfig.redirectUri}`;

}

export async function getUserId() {

    const idToken = await oktaToken('idToken');

    return idToken.claims.userID;

}

export function getReturnUri() {

    return `${window.location.origin}/`;

}

export async function initOkta() {

    window.tokenRequestInFlight = false;

    oktaConfig = getStore().getState().appConfig.okta;
    oktaConfig.tokenManager = {
        autoRenew: false
    };

    // override returnUri from okta config to support multiple urls

    oktaConfig.redirectUri = getReturnUri();

    authClient = new OktaAuth(oktaConfig);

    const authToken = await authClient.tokenManager.get('accessToken');
    const idToken = await authClient.tokenManager.get('idToken');
    const noTokens = (typeof authToken === 'undefined' || typeof idToken === 'undefined');

    if (noTokens) {

        await getOktaTokens(true);

    }

}

export function checkForIframe() {

    let inframe;

    try {

        inframe = window.self !== window.top;

    } catch (e) {

        inframe = true;

    }

    if (inframe) {

        parent.window.signinComplete();

    }

}



// WEBPACK FOOTER //
// ./src/shared/services/okta.js